module.exports = __webpack_public_path__ + "img/eye.21664450.svg";